/**
 * @generated SignedSource<<d0b302b43585bfd9a4ddf840c1c55ac5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorContent_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftItem" | "NftItemTileItemDetails_nftItem">;
  readonly " $fragmentType": "CreatorContent_nftItem";
};
export type CreatorContent_nftItem$key = {
  readonly " $data"?: CreatorContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorContent_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileItemDetails_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "dd8f81d54d0f1df01e87b0050ade5d0c";

export default node;
